import { EMPTY } from "rxjs";
export var networkNoticeGrantCoopRewardHandler = function (action$, state$, deps) { return function (res) {
    // TODO: Handle Coop Grant Rewards
    return EMPTY;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/handlers/networkNoticeGrantCoopRewardHandler.ts
// module id = 2010
// module chunks = 3